module.exports = __webpack_public_path__ + "img/search_new_tab.a23a33b6.png";